var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],staticClass:"px-8 py-4"},[_c('img',{staticClass:"w-full",attrs:{"src":_vm.blok.image.filename}})])}
var staticRenderFns = []

export { render, staticRenderFns }